import { render, staticRenderFns } from "./TintStyleForm.vue?vue&type=template&id=893517f4&"
import script from "./TintStyleForm.vue?vue&type=script&lang=js&"
export * from "./TintStyleForm.vue?vue&type=script&lang=js&"
import style0 from "./TintStyleForm.vue?vue&type=style&index=0&id=893517f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports